import Blackouts from 'modules/Admin/locations/Blackouts'

function BlackoutsPage() {
  return (
    <div className="h-full" data-testid="adminBlackoutsPage">
      <Blackouts />
    </div>
  )
}

export default BlackoutsPage
